import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import LeagueContainer from '../../../features/page/leaderboard/league/LeagueContainer'

interface IProps {
    className?: string
}

const LeaguePage: React.FC<IProps> = ({className}) => {
    return (
        <PageLayout title={'League'} className={className}>
            <LeagueContainer />
        </PageLayout>
    )
}

export default LeaguePage
